module.exports = __webpack_public_path__ + "img/Keap.3c32318d.png";